import "./ContactForm.css"
import React, { useRef, useState } from 'react'
import emailjs from 'emailjs-com'

const ContactForm = () => {
    const form = useRef();
    const [enviado, setEnviado] = useState(false);
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_75hxm2d', 'template_vud93ic', form.current, 'o4P7u8u4sJRhc8SgD')
        .then((result) => {
            console.log(result.text);
            setEnviado(true);
        }, (error) => {
            console.log(error.text);
        });
    };

    return(
        <div className="form-container">
            <h1>نسعد بالرد على الرسائل والاستفسارات</h1>
            <form ref={form} onSubmit={sendEmail}>
                <input type="text" name='name' placeholder="الاسم" required />
                <input type="email" name='email' placeholder="بريدك الإلكتروني" required />
                <input type="subject" name='subject' placeholder="الموضوع" />
                <textarea name="message" rows="7" placeholder="رسالتك" required></textarea>
                <button type='submit'>إرسال</button>
            </form>
            {enviado && <p className="confirmation-message">تم إرسال الرسالة بنجاح. شكرًا </p>}
        </div>
    )
}
export default ContactForm
